import {API_URL, apiPost} from '../api'
import {IEvent} from './getEventApi'

export const createEventApi = async (data: IEvent) => {
    return await apiPost(API_URL, 'admin/event', data)
}
